import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { colors, GridWrapper } from "../theme";
import bgMLetter from "../assets/bg-mletter.svg";

const Container = styled.div`
  background: white;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 8000;
  padding-top: 230px;
`;

const Wrapper = styled(GridWrapper)`
  align-items: center;
  background: url(${bgMLetter}) no-repeat left center;
  display: flex;
  justify-content: center;
  margin: auto;
  min-height: 328px;

  @media (max-width: 767px) {
    text-align: center;
  }

  > div {
    max-width: 600px;
  }

  h1 {
    color: black;
    font-size: 4.8rem;
    margin-bottom: 20px;
    text-transform: uppercase;

    @media (max-width: 1023px) {
      font-size: 4rem;
    }
  }

  p {
    font-size: 2rem;
    margin-bottom: 12px;

    @media (max-width: 767px) {
      font-size: 1.5rem;
    }
  }

  span {
    color: ${colors.primaryColor};
  }
`;

function ScriptError({ script }) {
  return (
    <Container>
      <Wrapper>
        <div>
          <h1>Une erreur est survenue</h1>
          <p>
            Vous utilisez probablement une extension sur votre navigateur qui a
            bloqué un script nécessaire à l'exécution de notre site.
          </p>
          <p>
            Veuillez autoriser ce script ( <span>{script}</span> ) ou désactiver
            votre extension puis recharger la page.
          </p>
        </div>
      </Wrapper>
    </Container>
  );
}

ScriptError.propTypes = {
  script: PropTypes.string.isRequired,
};

export default ScriptError;
